// v0.4.7+: 改 `flarum/common/app` (辉哥 2026-07-20 21:38 拍板, 砍 1.8 兼容)
import app from 'flarum/common/app';
const debugHelper = {
  isDebugMode() {
    return app.forum && app.forum.attribute('seedreamDebugMode') === true;
  },
  log() {
    if (this.isDebugMode()) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      console.log('[Seedream]', ...args);
    }
  },
  error() {
    if (this.isDebugMode()) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      console.error('[Seedream]', ...args);
    }
  },
  warn() {
    if (this.isDebugMode()) {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      console.warn('[Seedream]', ...args);
    }
  },
  info() {
    if (this.isDebugMode()) {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      console.info('[Seedream]', ...args);
    }
  }
};
export default debugHelper;
flarum.reg.add('ziiven-dress-up', 'admin/utils/debugHelper', debugHelper);